/**
 * 広告と目次をスクロールに追尾させる (PCのみ)
 **/

$(function() {

  //モバイルは対象外
  if ( $.device.isMobile() ) {
    return;
  }

  var win = $(window);
  var adHide = $('#ad-hide');
  var leftToc = $('.left-toc');
  var adSideBottom = $('.ad-side-bottom,.ads-pc_right_bottom');
  
  if ( !adHide || adHide.size() == 0 ) {
    return;
  }

  if ( leftToc && leftToc.size() != 0 ) {
    stickyToc();
  }

  if ( adSideBottom && adSideBottom.size() != 0 ) {
     stickyRightAd();
  }


  /* --- 目次の指定 --- */
  function stickyToc() { 

    var toPosi;/*移動量*/
    var toHeight = $('.left-toc').height() + $('.left-toc').outerHeight();/*移動部品の高さ*/
    var toPosiSet;/*移動量と移動部品の高さの合計に使用*/
    var nav = adSideBottom;

    var toc = $('.left-toc');
    var tocPosi = $('.left-toc').offset().top;
    var tocList = $('#left-toc .toc_list');

    //目次の高さを最適化する
    var tocListHeight = tocList.height();
    var desiredHeight = $(window).innerHeight() - 80;
    if ( tocListHeight > desiredHeight ) {
      tocList.height(desiredHeight);
    }

    win.on('scroll',function() {
      var adHideTop = $('#ad-hide').offset().top;/*追尾広告を消したい位置のタグにid名を指定(広告上のコピーライトに)*/
      var scr = win.scrollTop();

      toPosi = $('.left-toc').offset().top;
      toPosiSet = (toPosi + toHeight);

      /*上部への張り付き指定*/
      if(scr > tocPosi){
        toc.addClass('sticky-toc');
      }else{
        toc.removeClass('sticky-toc');
      }
      /*下の広告近く（id:adHide）にきたら非表示にする*/
      if(toPosiSet > adHideTop){
        $('.sticky-toc').css('display','none');
      }else{
        $('.sticky-toc').css('display','block');
      }
    });
  }


  /* --- 右広告の指定 --- */
  function stickyRightAd() { 

    var nav = adSideBottom;
    var adPosi;
    var adHeight = nav.height() + nav.outerHeight();
    var adPosiSet;
    var navPosi = nav.offset().top;


    win.on('scroll',function(){
      var scr = win.scrollTop();
      var adHideTop = $('#ad-hide').offset().top;/*追尾広告を消したい位置のタグにid名を指定(広告上のコピーライトに)*/

      adPosi = adSideBottom.offset().top;
      adPosiSet = (adPosi + adHeight);

      /*上部への張り付き指定*/
      if(scr > navPosi){
        if(adPosiSet < adHideTop){/*最初から接触している場合は追尾させない（右広告は内容が少ないと最初から下と接触している場合もあるため）*/
          nav.addClass('sticky-ad');
        }
      }else{
        nav.removeClass('sticky-ad');
      }

      /*下の広告近く（id:adHide）にきたら非表示にする(広告の位置が右エリア内で最下部であるのが前提での指定です)*/
      if(adPosiSet > adHideTop){
        $('.sticky-ad').css('display','none');
      }else{
        $('.sticky-ad').css('display','block');
      }

    });
  }

});
